/* eslint-disable react/forbid-dom-props */
import React from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet';
import { TransitionGroup } from 'react-transition-group';
import uuid from 'uuid';
import ClassActivatingTransition from '../ClassActivatingTransition';
import styles from './ModalContent.scss';
import Scroll from '../../other/Scroll';
import withTranslations from '../Translations/withTranslations';
import helpNoteTitleIfPresent from '../Translations/helpNoteTitleIfPresent';
const ModalContentClass = 'modal-content';
const MODAL_Z_INDEX = 1050;
const BACKDROP_Z_INDEX = 1040;
const NESTED_Z_INDEX_STEP = 2;
class ModalContent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.uniqId = uuid.v4();
        this.depth = ModalContent.openCount++;
        this.handleExited = () => {
            const { onFinishedHiding } = this.props;
            onFinishedHiding();
        };
        this.handleClick = event => {
            const { onClose } = this.props;
            onClose && onClose(event);
        };
        this.handleChildClick = event => event.stopPropagation();
    }
    componentWillUnmount() {
        ModalContent.openCount = Math.max(0, ModalContent.openCount - 1);
    }
    renderContent() {
        const { title, getHelpNoteTooltipTitle, size, className, children, direction, isLayoutRTL, onClose, renderFooter, isOverlayClickHidesModal, isCloseCrossVisible, } = this.props;
        return [
            <ClassActivatingTransition key={`${this.uniqId}-content`} activateClassName="in" timeout={200} onClick={isOverlayClickHidesModal ? this.handleClick : undefined} onExited={this.handleExited}>
        <Scroll className="fade" classNameInner={classnames('modal', className, styles.container)} 
            // eslint-disable-next-line react/forbid-component-props
            style={{ zIndex: MODAL_Z_INDEX + NESTED_Z_INDEX_STEP * this.depth }}>
          <div className={classnames('modal-dialog', size && `modal-${size}`)} data-layout-direction={direction} dir={direction} onClick={isOverlayClickHidesModal ? this.handleChildClick : undefined}>
            <div className={ModalContentClass} data-layout-direction={direction} dir={direction}>
              {(onClose && isCloseCrossVisible) || title ? (<div className={classnames('modal-header', {
                [styles.headerWithoutTitle]: !title,
            })}>
                  {title && (<h5 className={classnames('modal-title', styles.modal_title)} style={{ textAlign: isLayoutRTL ? 'right' : 'left' }} title={helpNoteTitleIfPresent(getHelpNoteTooltipTitle, title)}>
                      {title}
                    </h5>)}
                  {onClose && isCloseCrossVisible && (<button className={classnames('close', {
                [styles.shiftCloseButton]: !title,
            })} data-layout-direction={direction} dir={direction} style={{ float: 'none' }} type="button" onClick={onClose}>
                      ×
                    </button>)}
                </div>) : null}
              <div className="modal-body pt-0" data-layout-direction={direction} dir={direction}>
                {children}
              </div>
              {renderFooter && (<div className="modal-footer" data-layout-direction={direction} dir={direction}>
                  {renderFooter()}
                </div>)}
            </div>
          </div>
        </Scroll>
      </ClassActivatingTransition>,
            <ClassActivatingTransition key={`${this.uniqId}-overlay`} activateClassName="in" timeout={150}>
        <div key={`${this.uniqId}-overlay-fade`} className="modal-backdrop fade" style={{
                zIndex: this.depth
                    ? MODAL_Z_INDEX + NESTED_Z_INDEX_STEP * this.depth - 1
                    : BACKDROP_Z_INDEX,
            }}/>
      </ClassActivatingTransition>,
        ];
    }
    render() {
        const { hiding } = this.props;
        return [
            <Helmet key={`${this.uniqId}-helmet`}>
        <body className={classnames('modal-open', styles.containerBox)}/>
      </Helmet>,
            <TransitionGroup key={`${this.uniqId}-body`} appear>
        {!hiding && this.renderContent()}
      </TransitionGroup>,
        ];
    }
}
ModalContent.defaultProps = {
    title: null,
    size: null,
    renderFooter: null,
    className: '',
    onClose: null,
    hasCancel: false,
    isOverlayClickHidesModal: false,
    isCloseCrossVisible: true,
};
ModalContent.openCount = 0;
export default withTranslations(ModalContent);
